var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button } from "@mui/material";
import { ShowPreviewBeforeComplete } from "../types/forms";
import { FORM_BUTTON_TEXTS } from "../utils/constants";
var FormNavigationButtons = function (_a) {
    var isFirstPage = _a.isFirstPage, isLastPage = _a.isLastPage, handlePrevious = _a.handlePrevious, handleNext = _a.handleNext, isSubmitting = _a.isSubmitting, formData = _a.formData, _b = _a.isShowingPreview, isShowingPreview = _b === void 0 ? false : _b, onShowPreview = _a.onShowPreview;
    var showPreviewButton = isLastPage &&
        !isShowingPreview &&
        !!formData.showPreviewBeforeComplete &&
        formData.showPreviewBeforeComplete !== ShowPreviewBeforeComplete.NO_PREVIEW;
    return (_jsxs(Box, __assign({ sx: {
            display: "flex",
            justifyContent: "space-between",
            mt: 2,
            mb: 2,
            gap: 2,
        } }, { children: [!isFirstPage &&
                formData.showPrevButton === undefined &&
                !isShowingPreview ? (_jsx(Button, __assign({ onClick: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    handlePrevious();
                }, variant: "outlined", type: "button" }, { children: formData.pagePrevText || FORM_BUTTON_TEXTS.previous }))) : (_jsx("div", { style: { width: "100%" } })), !isShowingPreview && !isLastPage ? (_jsx(Button, __assign({ onClick: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    handleNext();
                }, variant: "contained", type: "button" }, { children: formData.pageNextText || FORM_BUTTON_TEXTS.next }))) : showPreviewButton ? (_jsx(Button, __assign({ onClick: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    onShowPreview === null || onShowPreview === void 0 ? void 0 : onShowPreview();
                }, variant: "contained", type: "button" }, { children: formData.previewText || FORM_BUTTON_TEXTS.preview }))) : (_jsx(Button, __assign({ type: "submit", variant: "contained", disabled: isSubmitting }, { children: isSubmitting
                    ? FORM_BUTTON_TEXTS.submitting
                    : formData.completeText || FORM_BUTTON_TEXTS.complete })))] })));
};
export default FormNavigationButtons;
